import * as Api from '../utils/API';
var sortBy = require('sort-by')
import {
    WHATSAPP_LIST_CONTATOS,
    WHATSAPP_LIST_CONTATOSLOADING,

    WHATSAPP_CONTATOPARC_UPDATE,
    WHATSAPP_CONTATOPARC_UPDATELOADING,

    WHATSAPP_CONTATOPARC_INSERT,
    WHATSAPP_CONTATOPARC_INSERTLOADING,

    WHATSAPP_CONTATO_GERAL_LISTLOADING,
    WHATSAPP_CONTATO_GERAL_LIST
} from '../actions/ActionsTypes';

// export const whatsappListaContatosAction = (entidade) => (dispatch) =>
//     new Promise(function (resolve, reject) {
//         Api.getListaContatos(entidade).then(data => {

//             let contatos = []
//             let mensagem = data[0].mensagem
//             let status = data[0].status

//             contatos = data;

//             if(contatos[0]?.dados!=null && contatos[0]?.dados!=undefined){
//                 contatos[0].dados = JSON.parse(contatos[0].dados);
//                 contatos[0].dados.sort(sortBy('-codcontato'));
//             }else{
//                 contatos[0].dados = [];
//             }

//             dispatch({ type: WHATSAPP_LIST_STATUS, status: status, mensagem: mensagem })
//             dispatch({ type: WHATSAPP_LIST_CONTATOS, payload: contatos[0].dados })
//             resolve([])
//         }).catch(error => {
//             console.log("error", error)
//             reject(error);
//         })


//     });

export const whatsappListaContatosFlagsAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        console.log("entidade: ", entidade);
        dispatch({ type: WHATSAPP_LIST_CONTATOSLOADING, payload: true })
        Api.getListaContatosFlags(entidade).then(dados => {
            dispatch({ type: WHATSAPP_LIST_CONTATOS, payload: dados })
            dispatch({ type: WHATSAPP_LIST_CONTATOSLOADING, payload: false })
            resolve([])
        }).catch(error => {
            console.log("error", error)
            //dispatch({ type: WHATSAPP_LIST_CONTATOSLOADING, payload: false })
            reject(error);
        })
    });

export const WhatsappUpdateContatoParcAction = (codparc, nomecontato, ad_whatsappcp, email, nunota, isprincipal, iscomercial, iscentregas, isnfe, dtfim, codcontato, codusu) => (dispatch) =>
    new Promise(function (resolve, reject) {
        //console.log("ENVIANDO UPDATE:", payload);
        console.log("codparc enviado para API:", codparc);
        dispatch({ type: WHATSAPP_CONTATOPARC_UPDATELOADING, payload: true })
        Api.updateContatosParceiros(codparc, nomecontato, ad_whatsappcp, email, nunota, isprincipal, iscomercial, iscentregas, isnfe, dtfim, codcontato, codusu)
            .then(dados => {
                dispatch({ type: WHATSAPP_CONTATOPARC_UPDATE, payload: dados })
                dispatch({ type: WHATSAPP_CONTATOPARC_UPDATELOADING, payload: false })
                resolve([])
            }).catch(error => {
                reject(error);
            })
    });

export const WhatsappInsertContatoParcAction = (codparc, nomecontato, ad_whatsappcp, email, isprincipal, iscomercial, iscentregas, isnfe, codusu) => (dispatch) =>
    new Promise(function (resolve, reject) {
        // console.log("codvend enviado para API:", codparc);
        dispatch({ type: WHATSAPP_CONTATOPARC_INSERTLOADING, payload: true })
        Api.postCriaContato(codparc, nomecontato, ad_whatsappcp, email, isprincipal, iscomercial, iscentregas, isnfe, codusu)
            .then(dados => {
                dispatch({ type: WHATSAPP_CONTATOPARC_INSERT, payload: dados })
                dispatch({ type: WHATSAPP_CONTATOPARC_INSERTLOADING, payload: false })
                resolve([])
            }).catch(error => {
                reject(error);
            })
    });


export const WhatsappContatoGeralListAction = (codparc) => (dispatch) =>
    new Promise(function (resolve, reject) {
        console.log("codvend enviado para API:", codparc);
        dispatch({ type: WHATSAPP_CONTATO_GERAL_LISTLOADING, payload: true })
        Api.getContatoListaGeral(codparc).then(dados => {
            dispatch({ type: WHATSAPP_CONTATO_GERAL_LIST, payload: dados })
            dispatch({ type: WHATSAPP_CONTATO_GERAL_LISTLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });